module.exports = __webpack_public_path__ + "img/No-Image-Placeholder-banner.6a1353cb.svg";